import { InvalidValues } from '@amzn/awscat-portfolio-assessment-types';
import { Alert, Button, Modal } from '@amzn/awsui-components-react';
import React from 'react';

import { constants } from '../../../../common/Localization';

interface Props {
    visible: boolean;
    invalidValues: InvalidValues;
    cancel: () => void;
    continue: () => void;
}

export function InvalidDataModal(props: Props) {
    const invalidMessage = Object.keys(props.invalidValues).map((headerName, index) => {
        return (
            <li key={index}>
                {constants.INVALID_DATA_MODAL_MESSAGE.COLUMN_LABEL} {headerName}
                , {constants.INVALID_DATA_MODAL_MESSAGE.COUNT_LABEL} {props.invalidValues[headerName]}
            </li>
        );
    });

    const footer = (
        <span className='awsui-util-f-r'>
            <Button variant='link' onClick={props.cancel}>
                {constants.INVALID_DATA_MODAL_MESSAGE.CANCEL_BUTTON}
            </Button>
            <Button variant='primary' onClick={props.continue}>
                {constants.INVALID_DATA_MODAL_MESSAGE.CONTINUE_BUTTON}
            </Button>
        </span>
    );

    return (
        <div>
            <Modal
                visible={props.visible}
                header={constants.INVALID_DATA_MODAL_MESSAGE.MODAL_HEADER}
                footer={footer}
            >
                <Alert>
                    {constants.INVALID_DATA_MODAL_MESSAGE.ALERT_MESSAGE_GENERAL}
                    <ul>
                        {invalidMessage}
                    </ul>
                    {constants.INVALID_DATA_MODAL_MESSAGE.ALERT_MESSAGE_HINT}
                </Alert>
            </Modal>
        </div>
    );
}
